<template>
	<div class="row centered wrapper-buttons-table">
		<AppTableButton
			v-for="(button, index) in buttons"
			:key="index"
			:title="button.title"
			:icon-name="button.iconName"
			:prevent-change="button.hasOwnProperty('preventChange') ? button.preventChange : true"
			:color="button.color || 'var(--color-fill-button-table)'"
			:color-loader="button.colorLoader || 'var(--color-primary)'"
			:loading="button.loading || false"
			:disabled="button.disabled || false"
			:class="button.class || ''"
			:active="activeButton(button)"
			@click="handleClickIcon(button)" />
	</div>
</template>

<script>
import AppTableButton from "@/shared/components/AppTableButton.vue";

export default {
	name: "AppTableButtonGroup",
	components: {AppTableButton},
	emits: ["click-icon"],
	props: {
		buttons: {
			type: Array,
			required: true,
			validator: function(value) {
				return value.every(button => button.iconName || button.title);
			}
		},
		item: {
			type: Object,
			default: {}
		}
	},
	methods: {
		activeButton(button) {
			return button.active || (button?.activeFunction && this.item ? button.activeFunction(this.item) : false);
		},
		handleClickIcon(button) {
			if(button.emitName) {
				this.$emit(button.emitName, button);
			} else {
				this.$emit("click-icon", button);
			}
		}
	}
}
</script>